<template>
  <div
    class="order_card"
    :class="{
      order_card_finished: row.isFinishOrder === 1 || row.isDeleted === 1
    }"
  >
    <!-- 头部 -->
    <div class="order_card_header">
      <div class="order_card_header_left">
        <!-- <el-checkbox
          v-model="isSelected"
          class="order_card_checkbox"
        /> -->
        <span class="order_card_order_no">{{
          row.mainOrderNumber || "--"
        }}</span>
        <span :class="['order_card_badge', statusBadgeClass]">
          {{ statusText }}
        </span>
        <span
          v-if="row.isFinishOrder === 1"
          class="order_card_badge order_card_badge_finished"
        >
          已结束
        </span>
        <span
          v-if="row.isCancel === 1"
          class="order_card_badge order_card_badge_cancel"
        >
          已撤销
        </span>
        <span
          v-if="row.isDeleted === 1"
          class="order_card_badge order_card_badge_cancel"
        >
          已取消
        </span>
        <span
          v-if="receiveOrderMethodText"
          class="order_card_badge order_card_badge_default"
        >
          {{ receiveOrderMethodText }}
        </span>
        <span
          v-if="row.isOftenOrder === 1"
          class="order_card_badge order_card_badge_orange"
        >
          常发货源
        </span>
      </div>
      <div class="order_card_header_right">
        <!-- 项目名称，线路名称，来源单号 -->
        <div
          v-for="item in editableFields"
          :key="item.field"
          class="order_card_edit_wrap"
        >
          <span
            v-if="editingField !== item.field"
            class="order_card_edit_tag"
            @click="startFieldEdit(item.field)"
          >
            <i class="el-icon-edit" />
            <span>{{ item.label }}：{{ row[item.field] || "--" }}</span>
          </span>
          <span v-else class="order_card_edit_tag order_card_edit_tag_editing">
            <span>{{ item.label }}：</span>
            <el-input
              v-model="editValue"
              size="mini"
              class="order_card_edit_input"
              @keyup.enter.native="confirmFieldEdit(item.field)"
            />
            <el-button
              type="text"
              size="mini"
              @click="confirmFieldEdit(item.field)"
            >
              <i class="el-icon-check" style="color: #67c23a;" />
            </el-button>
            <el-button type="text" size="mini" @click="cancelFieldEdit">
              <i class="el-icon-close" style="color: #f56c6c;" />
            </el-button>
          </span>
        </div>
        <!-- 次结，月结 -->
        <!-- <span>结算方式：{{ monthlyOrderText }}</span> -->
      </div>
    </div>
    <!-- 托运人信息 -->
    <div class="order_card_shipper">
      <span class="order_card_shipper_label">托运人：</span>
      <span class="order_card_shipper_company">{{
        row.companyName || "--"
      }}</span>
      <span class="order_card_shipper_contact"
        >{{ row.dfName || "--" }} · {{ row.dfPhone || "--" }}</span
      >
      <!-- 承运 -->
      <span class="order_card_shipper_carrier">
        <span class="order_card_shipper_label" style="color: #8993A4;"
          >承运主体:</span
        >
        <span
          class="order_card_shipper_company"
          style="color: #8993A4;font-weight: 400;"
          >{{ branchName }}</span
        >
      </span>
    </div>

    <!-- 主体 7 列 -->
    <div class="order_card_body">
      <!-- 装卸货信息 -->
      <div class="order_card_col">
        <div class="order_card_col_title">
          <span class="order_card_bar order_card_bar_green" />
          装卸货信息
        </div>
        <div class="order_card_address_item">
          <div class="order_card_timeline">
            <span class="order_card_time_tag order_card_time_tag_blue">装</span>
            <i class="order_card_timeline_line" />
          </div>
          <div>
            <div class="order_card_address_main">
              {{ row.placeOfShipment || "--" }}
            </div>
            <!-- 联系人电话 -->
            <div class="order_card_sub">
              {{ row.consignorName || row.shipperName || "--" }} ·
              {{ row.consignorPhone || row.shipperPhone || "--" }}
            </div>
            <div class="order_card_sub order_card_time_row">
              <span class="order_card_dot order_card_dot_blue" />
              <span>{{ row.lastLoadingTime || "--" }}</span>
            </div>
          </div>
        </div>
        <div class="order_card_address_item">
          <div class="order_card_timeline">
            <span class="order_card_time_tag order_card_time_tag_green"
              >卸</span
            >
          </div>
          <div>
            <div class="order_card_address_main">
              {{ row.placeOfReceipt || "--" }}
            </div>
            <!-- 联系人电话 -->
            <div class="order_card_sub">
              {{ row.consigneeName || "--" }} ·
              {{ row.consigneePhone || "--" }}
            </div>
            <div class="order_card_sub order_card_time_row">
              <span class="order_card_dot order_card_dot_green" />
              <span>{{ row.lastUnloadingTime || "--" }}</span>
            </div>
          </div>
        </div>
        <div class="order_card_stats">
          <span class="order_card_stats_tag">运距 {{ distanceText }}</span>
          <span v-if="row.takeTime" class="order_card_stats_tag"
            >约 {{ row.takeTime || "--" }}小时</span
          >
          <span class="order_card_stats_tag">整车运输</span>
        </div>
      </div>

      <!-- 车货信息 -->
      <div class="order_card_col order_card_col_goods">
        <div class="order_card_goods_head">
          <div class="order_card_goods_head_left">
            <span class="order_card_bar order_card_bar_cyan" />
            车货信息
          </div>
          <span v-if="row.coalName" class="order_card_goods_require"
            >要求：{{ row.coalName }}</span
          >
        </div>
        <div class="order_card_goods_main">
          <span class="order_card_goods_name">{{
            row.coalTypeName || row.coalBigTypeName || "--"
          }}</span>
          <span class="order_card_goods_weight">{{ goodsWeightText }}</span>
        </div>
        <div class="order_card_kv">
          <span class="order_card_kv_label">货物单价</span>
          <span class="order_card_kv_value">{{ coalPriceText }}</span>
        </div>
        <div class="order_card_kv">
          <span class="order_card_kv_label">剩余数量</span>
          <span class="order_card_kv_value">{{ remainWeightText }}</span>
        </div>
        <div class="order_card_kv">
          <span class="order_card_kv_label">车型车长</span>
          <span class="order_card_kv_value">{{ carSpecText }}</span>
        </div>
        <div class="order_card_kv">
          <span class="order_card_kv_label">用车需求</span>
          <span class="order_card_kv_value">{{ vehicleNeedText }}</span>
        </div>
        <!-- <div class="order_card_progress">
          <div class="order_card_progress_bar">
            <div
              class="order_card_progress_fill"
              :style="{ width: progressPercent + '%' }"
            />
          </div>
          <div class="order_card_progress_labels">
            <span class="order_card_progress_received"
              >已接 {{ receivedCount }}</span
            >
            <span class="order_card_progress_unreceived"
              >未接 {{ notReceivedCount }}</span
            >
          </div>
        </div> -->
      </div>

      <!-- 车型/车长 -->
      <div v-if="false" class="order_card_col">
        <div class="order_card_col_title">
          <span class="order_card_bar order_card_bar_cyan" />
          车型 / 车长
        </div>
        <div class="order_card_tags">
          <span
            v-if="carLengthNames"
            class="order_card_tag order_card_tag_teal"
            >{{ carLengthNames }}</span
          >
          <span
            v-if="carModelNames"
            class="order_card_tag order_card_tag_teal"
            >{{ carModelNames }}</span
          >
          <span
            v-if="!carLengthNames && !carModelNames"
            class="order_card_tag order_card_tag_teal"
            >--</span
          >
        </div>
        <div class="order_card_sub">用车需求 {{ row.coalNumber || 0 }} 辆</div>
        <div class="order_card_progress">
          <div class="order_card_progress_bar">
            <div
              class="order_card_progress_fill"
              :style="{ width: progressPercent + '%' }"
            />
          </div>
          <div class="order_card_progress_labels">
            <span class="order_card_progress_received"
              >已接 {{ receivedCount }}</span
            >
            <span class="order_card_progress_unreceived"
              >未接 {{ notReceivedCount }}</span
            >
          </div>
        </div>
        <div class="order_card_sub">
          匹配实际承运人 {{ row.pushTargetName || "--" }}
        </div>
      </div>

      <!-- 费用信息 -->
      <div class="order_card_col">
        <div class="order_card_col_title">
          <span class="order_card_bar order_card_bar_brown" />
          费用信息 (预估)
        </div>
        <div class="order_card_kv">
          <span class="order_card_kv_label">运费单价</span>
          <span class="order_card_kv_value">{{ freightPriceText }}</span>
        </div>
        <div class="order_card_kv">
          <span class="order_card_kv_label">预估实际承运人运费</span>
          <span class="order_card_kv_value order_card_fee_blue"
            >¥{{ formatMoney(row.dirverEstimatePay) }}</span
          >
        </div>
        <div class="order_card_kv">
          <span class="order_card_kv_label">平台服务费</span>
          <span class="order_card_kv_value order_card_fee_orange"
            >¥{{ formatMoney(row.serInfoPay) }}</span
          >
        </div>
        <div class="order_card_kv">
          <span class="order_card_kv_label">预估托运人费用</span>
          <span class="order_card_kv_value order_card_fee_total"
            >¥{{ formatMoney(row.shipperEstimatePay) }}</span
          >
        </div>
        <div class="order_card_kv">
          <span class="order_card_kv_label">签收回单</span>
          <span class="order_card_kv_value">{{ returnPayText }}</span>
        </div>
        <div class="order_card_pay_tags">
          <span
            v-if="hasPrePay"
            class="order_card_pay_tag order_card_pay_tag_pre"
          >
            预付 ¥{{ formatMoney(row.prePay) }}
          </span>
          <span
            v-if="row.arrivePayType == 1"
            class="order_card_pay_tag order_card_pay_tag_arrive"
          >
            到付 ¥{{ formatMoney(row.arrivePay) }}
          </span>
          <span
            v-if="row.returnPayType == 1"
            class="order_card_pay_tag order_card_pay_tag_return"
          >
            回单付 ¥{{ formatMoney(row.returnPay) }}
          </span>
        </div>
      </div>

      <!-- 增值服务 -->
      <div v-if="row.oilFee > 0" class="order_card_col">
        <div class="order_card_col_title">
          <span class="order_card_bar order_card_bar_green2" />
          增值服务
        </div>
        <div class="order_card_kv">
          <span class="order_card_kv_label">油气配置</span>
          <span class="order_card_kv_value order_card_oil_fee_value"
            >配额{{ oilFeeText }}</span
          >
        </div>
        <div class="order_card_kv">
          <span class="order_card_kv_label">
            预估优惠金额:
          </span>
          <span class="order_card_kv_value"
            >￥{{ row.discountServiceFee || 0 }}</span
          >
        </div>
      </div>

      <!-- 接单进度·操作 -->
      <!-- <div class="order_card_col order_card_col_actions">
        <div class="order_card_col_title">
          <span class="order_card_bar order_card_bar_purple" />
          接单进度
        </div>
        <div class="order_card_progress_text">
          <span class="order_card_progress_num">{{ receivedCount }}</span>
          / {{ row.coalNumber || 0 }} 车已接
        </div>
      <div class="order_card_progress">
        <div class="order_card_progress_bar">
          <div
            class="order_card_progress_fill"
            :style="{ width: progressPercent + '%' }"
          />
        </div>
        <div class="order_card_progress_labels">
          <span
            class="order_card_progress_received"
          >已接 {{ receivedCount }}</span>
          <span
            class="order_card_progress_unreceived"
          >未接 {{ notReceivedCount }}</span>
        </div>
      </div>
    </div> -->
    </div>

    <!-- 底部 -->
    <div class="order_card_footer">
      <div class="order_card_footer_left">
        <span>创建时间: {{ row.gmtCreated }}</span>
        <span>最后操作时间: {{ row.gmtModified }}</span>
        <span v-if="row.modifiedByName"
          >最后操作人: {{ row.modifiedByName || "--" }}</span
        >
      </div>
      <div class="order_card_btns">
        <el-button
          v-if="permissions.detail"
          type="primary"
          size="mini"
          class="order_card_btn_detail"
          @click="$emit('detail', row)"
        >
          详情
        </el-button>
        <el-button
          v-if="permissions.copy"
          size="mini"
          @click="$emit('copy', row)"
        >
          再来一单
        </el-button>
        <el-button
          v-if="showDistrBtn && !isOrderFinished"
          size="mini"
          @click="$emit('dispatch', row)"
        >
          指派实际承运人
        </el-button>
        <!-- <el-button
          v-if="row.btnArr && row.btnArr.indexOf('edit') > -1"
          size="mini"
          @click="$emit('edit', row)"
        >
          编辑
        </el-button> -->
        <!-- <el-button
          size="mini" 
          class="order_card_btn_qrcode"
          @click="$emit('qrcode', row)"
        >
          <i class="el-icon-full-screen" />
          二维码
        </el-button> -->
        <el-dropdown
          v-if="showMoreDropdown"
          trigger="click"
          @command="cmd => $emit('more', { command: cmd, row })"
        >
          <el-button size="mini">
            更多<i class="el-icon-arrow-down el-icon--right" />
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <template v-if="!isOrderFinished">
              <el-dropdown-item
                v-if="row.btnArr.indexOf('edit') > -1"
                command="edit"
              >
                编辑
              </el-dropdown-item>
              <el-dropdown-item
                v-if="permissions.endSource && row.isFinishOrder === 0"
                command="endSource"
              >
                结束货源单
              </el-dropdown-item>
              <el-dropdown-item
                v-if="row.btnArr.indexOf('enclosure') > -1"
                command="enclosure"
              >
                电子围栏
              </el-dropdown-item>
              <el-dropdown-item
                v-if="row.btnArr.indexOf('suspend') > -1"
                command="suspend"
              >
                暂停
              </el-dropdown-item>
              <el-dropdown-item
                v-if="row.btnArr.indexOf('orderrefresh') > -1"
                command="orderrefresh"
              >
                刷新
              </el-dropdown-item>
              <el-dropdown-item
                v-if="row.btnArr.indexOf('reject') > -1"
                command="reject"
              >
                调价
              </el-dropdown-item>
              <el-dropdown-item
                v-if="row.btnArr.indexOf('offer') > -1"
                command="offer"
              >
                报价
              </el-dropdown-item>
              <el-dropdown-item
                v-if="row.btnArr.indexOf('paidanList') > -1"
                command="paidanList"
              >
                派单列表
              </el-dropdown-item>
              <el-dropdown-item
                v-if="row.btnArr.indexOf('cancelOftenOrder') > -1"
                command="cancelOftenOrder"
              >
                取消常发
              </el-dropdown-item>
              <el-dropdown-item
                v-if="
                  row.btnArr.indexOf('delete') > -1 &&
                    row.isFinishOrder !== 1 &&
                    row.isDeleted !== 1
                "
                command="delete"
              >
                取消
              </el-dropdown-item>
              <el-dropdown-item command="qrcode">查看二维码</el-dropdown-item>
              <el-dropdown-item
                v-if="permissions.simpleQrcode"
                command="simpleQrcode"
              >
                查看简易二维码
              </el-dropdown-item>
            </template>
            <el-dropdown-item
              v-if="permissions.editGoodType"
              command="editGoodType"
            >
              修改货物类型
            </el-dropdown-item>
            <el-dropdown-item v-if="permissions.log" command="log">
              操作日志
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { parseTime } from "@/utils";
import { updateProjectInfo } from "@/api/orderform";

export default {
  name: "OrderCardItem",
  props: {
    row: { type: Object, required: true },
    branchList: { type: Array, default: () => [] },
    carLengthOptions: { type: Array, default: () => [] },
    carModelOptions: { type: Array, default: () => [] },
    selected: { type: Boolean, default: false },
    permissions: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      editingField: null,
      editValue: "",
      editableFields: [
        { field: "projectName", label: "项目" },
        { field: "lineName", label: "线路" },
        { field: "sourceOrderNumber", label: "来源单号" }
      ]
    };
  },
  computed: {
    isSelected: {
      get() {
        return this.selected;
      },
      set(val) {
        this.$emit("select-change", val);
      }
    },
    branchName() {
      const item = this.branchList.find(
        item => item.code === this.row.branchCode
      );
      return item ? item.groupName : "--";
    },
    statusText() {
      const status = this.row.status;
      const statusMap = {
        0: "未接单",
        1: "已接单",
        2: "已装货",
        3: "已卸货",
        4: "已核算",
        5: "已完成"
      };
      return statusMap[status] || "--";
    },
    statusBadgeClass() {
      if (this.row.status === 0 && this.row.isCancel !== 1) {
        return "order_card_badge_publishing";
      }
      return "order_card_badge_primary";
    },
    receiveOrderMethodText() {
      if (this.row.pushTargetName) return "指派实际承运人";
      if (this.row.receiveOrderMethod === 0) return "发布至大厅";
      if (this.row.receiveOrderMethod === 1) return "仅扫码接单";

      return "";
    },
    monthlyOrderText() {
      if (this.row.isMonthlyOrder === 0) return "次结";
      if (this.row.isMonthlyOrder === 1) return "月结";
      return "--";
    },
    weightText() {
      const w = this.row.weight;
      if (w === null || w === undefined || w === "") return "";
      return String(w);
    },
    goodsWeightText() {
      const w = this.row.weight;
      if (w === null || w === undefined || w === "") return "--";
      return `${w}`;
    },
    remainWeightText() {
      const w = this.row.lastWeight || this.row.weight;
      if (w === null || w === undefined || w === "") return "--";
      return `${w}`;
    },
    coalPriceText() {
      const v = this.row.coalPrice;
      if (v === null || v === undefined || v === "") return "--";
      return `¥ ${v}`;
    },
    carSpecText() {
      const length = this.mapDictCodesToNames(
        this.row.carLength,
        this.carLengthOptions
      );
      const model = this.mapDictCodesToNames(
        this.row.carModel,
        this.carModelOptions
      );
      if (!length && !model) return "--";
      if (length && model) return `${length} · ${model}`;
      return length || model;
    },
    carLengthNames() {
      return this.mapDictCodesToNames(
        this.row.carLength,
        this.carLengthOptions
      );
    },
    carModelNames() {
      return this.mapDictCodesToNames(this.row.carModel, this.carModelOptions);
    },
    freightPriceText() {
      const p = this.row.price;
      if (p === null || p === undefined || p === "") return "--";
      const text = String(p);
      // 列表接口处理后可能已带 isTrunkName（如 /车、/吨）
      if (text.includes("/")) return `¥${text}`;
      const unit = this.row.isTrunkName || "";
      return `¥${text}${unit}`;
    },
    hasPrePay() {
      const v = this.row.prePay;
      if (v === null || v === undefined || v === "") return false;
      return Number(v) > 0 || this.row.payType == 1;
    },
    vehicleNeedText() {
      return `${this.row.coalNumber || 0}辆（已接 ${this.receivedCount}）`;
    },
    goodsTotalText() {
      const v = this.row.goodsTotal;
      if (v === null || v === undefined || v === "" || v === 0) return "未申报";
      return `¥${v}`;
    },
    distanceText() {
      const d = this.row.distance;
      if (d === null || d === undefined || d === "") return "--";
      return `${d} km`;
    },
    receivedCount() {
      return Number(this.row.receivedCount) || 0;
    },
    notReceivedCount() {
      return Number(this.row.notReceivedCount) || 0;
    },
    progressPercent() {
      const total = Number(this.row.coalNumber) || 0;
      if (!total) return 0;
      return Math.min(100, (this.receivedCount / total) * 100);
    },
    oilFeeText() {
      const v = this.row.oilFee;
      if (v === null || v === undefined || v === "" || v === 0) return "未配置";
      return `¥${v}`;
    },
    returnPayText() {
      if (this.row.isOrderReturn == 1) return "需要";
      return "不需要";
    },
    isOrderFinished() {
      return this.row.isFinishOrder === 1 || this.row.isDeleted === 1;
    },
    showMoreDropdown() {
      if (this.isOrderFinished) {
        return !!(this.permissions.log || this.permissions.editGoodType);
      }
      return this.row.btnArr && this.row.btnArr.length > 0;
    },
    showDistrBtn() {
      return (
        this.permissions.dispatch &&
        this.row.isCancel === 0 &&
        this.row.isFinishOrder === 0
      );
    }
  },
  methods: {
    mapDictCodesToNames(codesStr, options) {
      const codes = String(codesStr || "")
        .split(",")
        .map(item => item.trim())
        .filter(Boolean);
      if (!codes.length) return "";
      return codes
        .map(code => {
          const item = (options || []).find(opt => opt.code === code);
          return item ? item.name : code;
        })
        .join(",");
    },
    formatDate(val) {
      if (!val) return "--";
      return parseTime(val, "{m}-{d} {h}:{i}");
    },
    formatMoney(val) {
      if (val === null || val === undefined || val === "") return "--";
      const num = Number(val);
      if (Number.isNaN(num)) return val;
      return num.toFixed(2);
    },
    startFieldEdit(field) {
      this.editingField = field;
      this.editValue = this.row[field] || "";
    },
    cancelFieldEdit() {
      this.editingField = null;
      this.editValue = "";
    },
    async confirmFieldEdit(field) {
      if (this.editValue === (this.row[field] || "")) {
        this.cancelFieldEdit();
        return;
      }
      const params = { code: this.row.code };
      params[field] = this.editValue;
      try {
        await updateProjectInfo(params);
        this.$message.success("修改成功");
        this.$set(this.row, field, this.editValue);
        this.cancelFieldEdit();
        this.$emit("refresh");
      } catch (error) {
        this.cancelFieldEdit();
      }
    }
  }
};
</script>

<style scoped>
.order_card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}
.order_card_finished {
  background: #f5f5f5;
}
.order_card_finished .order_card_shipper {
  background: #f5f5f5;
}
.order_card_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  border-bottom: 1px solid #ebeef5;
}
.order_card_header_left {
  display: flex;
  align-items: center;
  gap: 8px;
}
.order_card_shipper {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  font-size: 13px;
  line-height: 1.4;
  border-bottom: 1px solid #ebeef5;
  background: #fbfcfd;
}
.order_card_shipper_label {
  flex-shrink: 0;
  color: #909399;
}
.order_card_shipper_company {
  margin-right: 16px;
  color: #303133;
  font-weight: 600;
}
.order_card_shipper_contact {
  color: #909399;
  font-weight: bold;
}
.order_card_shipper_carrier {
  display: inline-flex;
  align-items: center;
  margin-left: auto;
}
.order_card_header_right {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #909399;
}
.order_card_edit_tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 220px;
  padding: 2px 8px;
  font-size: 12px;
  color: #606266;
  background: #f4f4f5;
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
}
.order_card_edit_tag > span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.order_card_edit_tag .el-icon-edit {
  flex-shrink: 0;
  font-size: 12px;
  color: #909399;
}
.order_card_edit_tag_editing {
  max-width: none;
  cursor: default;
}
.order_card_edit_input {
  width: 120px;
}
.order_card_edit_tag_editing .el-button {
  padding: 0;
  margin-left: 0;
}
.order_card_checkbox {
  margin-right: 4px;
}
.order_card_order_no {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}
.order_card_badge {
  padding: 2px 8px;
  font-size: 12px;
  border-radius: 4px;
}
.order_card_badge_primary {
  color: #409eff;
  background: #ecf5ff;
  border: 1px solid #d9ecff;
}
.order_card_badge_publishing {
  background: #edf2ff;
  border-radius: 4px;
  font-size: 12px;
  color: #2e5ff0;
}
.order_card_badge_finished {
  background: #efefef;
  font-weight: 400;
  font-size: 12px;
  color: #333333;
}
.order_card_badge_cancel {
  color: #f56c6c;
  background: #fef0f0;
  border: 1px solid #fde2e2;
}
.order_card_badge_default {
  color: #606266;
  background: #ffffff;
  border: 1px solid #e9e9eb;
}
.order_card_badge_orange {
  color: #e6a23c;
  background: #fdf6ec;
  border: 1px solid #faecd8;
}
.order_card_divider {
  color: #dcdfe6;
}
.order_card_body {
  display: flex;
  min-height: 200px;
}
.order_card_col {
  flex: 1;
  min-width: 0;
  padding: 12px;
  padding-left: 30px;
  padding-right: 30px;
  border-right: 1px solid #ebeef5;
  font-size: 12px;
  color: #606266;
}
.order_card_col:last-child {
  border-right: none;
}
.order_card_col_actions {
  flex: 0.9;
}
.order_card_col_title,
.order_card_goods_head_left {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #697386;
}
.order_card_col_title {
  margin-bottom: 10px;
}
.order_card_goods_head_left {
  flex-shrink: 0;
}
.order_card_bar {
  width: 3px;
  height: 14px;
  border-radius: 2px;
}
.order_card_bar_blue {
  background: #409eff;
}
.order_card_bar_green {
  background: #67c23a;
}
.order_card_bar_orange {
  background: #e6a23c;
}
.order_card_bar_cyan {
  background: #13c2c2;
}
.order_card_bar_brown {
  background: #c97b3a;
}
.order_card_bar_green2 {
  background: #52c41a;
}
.order_card_bar_purple {
  background: #9254de;
}
.order_card_company_name {
  margin-bottom: 4px;
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.order_card_sub {
  margin-bottom: 4px;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}
.order_card_address_item .order_card_sub:not(.order_card_time_row) {
  font-weight: 400;
  font-size: 13px;
  color: #707a8a;
}
.order_card_tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 6px 0;
}
.order_card_tag {
  padding: 1px 6px;
  font-size: 11px;
  color: #606266;
  background: #f4f4f5;
  border: 1px solid #e9e9eb;
  border-radius: 3px;
}
.order_card_tag_teal {
  color: #13c2c2;
  background: #e6fffb;
  border-color: #b5f5ec;
}
.order_card_platform {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed #ebeef5;
}
.order_card_platform_label {
  display: block;
  font-size: 11px;
  color: #909399;
}
.order_card_platform_value {
  font-size: 12px;
  color: #409eff;
}
.order_card_address_item {
  display: flex;
  gap: 6px;
  margin-bottom: 8px;
  overflow: visible;
}
.order_card_timeline {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  flex-shrink: 0;
  width: 20px;
}
.order_card_timeline_line {
  flex: 1;
  width: 0;
  min-height: 12px;
  margin-top: 4px;
  margin-bottom: -8px;
  border-left: 1px dashed #c0c4cc;
}
.order_card_dot {
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.order_card_dot_blue {
  background: #409eff;
}
.order_card_dot_green {
  background: #67c23a;
}
.order_card_time_row {
  display: flex;
  align-items: center;
  gap: 6px;
}
.order_card_time_tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  border-radius: 50%;
  box-sizing: border-box;
}
.order_card_time_tag_blue {
  color: #409eff;
  border: 1px solid #409eff;
}
.order_card_time_tag_green {
  color: #67c23a;
  border: 1px solid #67c23a;
}
.order_card_address_main {
  font-weight: 600;
  font-size: 15px;
  color: #333333;
  line-height: 1.4;
  word-break: break-all;
}
.order_card_stats {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed #ebeef5;
  font-size: 11px;
  color: #909399;
}
.order_card_stats_tag {
  padding: 2px 5px;
  font-size: 13px;
  color: #697386;
  background: #f5f6f8;
  border-radius: 4px;
}
.order_card_col_goods {
  border-radius: 4px;
  color: #697386;
}
.order_card_goods_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
}
.order_card_goods_require {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 400;
  color: #697386;
  text-align: right;
}
.order_card_goods_main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}
.order_card_goods_name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}
.order_card_goods_weight {
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 600;
  font-size: 13px;
  color: #65748a;
}
.order_card_goods_title {
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #303133;
}
.order_card_kv {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
  font-size: 13px;
  color: #697386;
}
.order_card_kv_label {
  flex-shrink: 0;
  color: #697386;
}
.order_card_kv_value {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #697386;
  text-align: right;
}
.order_card_oil_fee_value {
  font-weight: 600;
  font-size: 13px;
  color: #f15a00;
}
.order_card_note {
  margin-top: 8px;
  padding: 6px 8px;
  font-size: 11px;
  color: #909399;
  background: #f5f7fa;
  border-radius: 4px;
}
.order_card_progress {
  margin: 8px 0;
}
.order_card_progress_bar {
  height: 6px;
  background: #ebeef5;
  border-radius: 3px;
  overflow: hidden;
}
.order_card_progress_fill {
  height: 100%;
  background: #13c2c2;
  border-radius: 3px;
  transition: width 0.3s;
}
.order_card_progress_labels {
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
  font-size: 11px;
}
.order_card_progress_received {
  color: #13c2c2;
}
.order_card_progress_unreceived {
  color: #909399;
}
.order_card_fee_blue {
  color: #409eff;
}
.order_card_fee_orange {
  color: #e6a23c;
}
.order_card_fee_total {
  font-size: 15px;
  font-weight: 700;
  color: #e6a23c;
}
.order_card_pay_tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}
.order_card_pay_tag {
  display: inline-block;
  padding: 2px 8px;
  font-size: 11px;
  border-radius: 4px;
}
.order_card_pay_tag_pre {
  color: #67c23a;
  background: #f0f9eb;
}
.order_card_pay_tag_arrive {
  color: #e6a23c;
  background: #fdf6ec;
}
.order_card_pay_tag_return {
  color: #409eff;
  background: #ecf5ff;
}
.order_card_fee_tip {
  margin-top: 6px;
  font-size: 10px;
  color: #c0c4cc;
  line-height: 1.4;
}
.order_card_progress_text {
  margin-bottom: 6px;
  font-size: 12px;
  color: #606266;
}
.order_card_progress_num {
  font-size: 20px;
  font-weight: 700;
  color: #303133;
}
.order_card_fence_tag {
  display: inline-block;
  margin-bottom: 8px;
  padding: 2px 8px;
  font-size: 11px;
  color: #909399;
  background: #f4f4f5;
  border-radius: 4px;
}
.order_card_btns {
  display: flex;
  gap: 6px;
}
.order_card_btn_detail {
  background: #2e5ff0;
  border-color: #2e5ff0;
}
.order_card_btn_detail:hover,
.order_card_btn_detail:focus {
  background: #2e5ff0;
  border-color: #2e5ff0;
}
.order_card_btn_dispatch {
  color: #13c2c2;
  border-color: #b5f5ec;
  background: #e6fffb;
}
.order_card_btn_qrcode {
  color: #9254de;
  border-color: #d3adf7;
  background: #f9f0ff;
}
.order_card_footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  border-top: 1px solid #ebeef5;
  background: #fafafa;
  font-size: 12px;
  color: #909399;
}
.order_card_footer_left {
  display: flex;
  gap: 16px;
}
.order_card_log_link {
  color: #409eff;
  cursor: pointer;
}
.order_card_log_link:hover {
  opacity: 0.85;
}
</style>
